export default __webpack_public_path__ + "static/media/proposals.66186725.svg";